<template>
  <div class="views-health-notice">
    <!-- header头 -->
    <div class="header">
      <div class="back-btn" @click="goBack"><img src="@/assets/images/icon-back.png"></div>
      <div class="title">健康告知</div>
    </div>
    <div class="content-wrapper">
      <ManBing :planId="planId"></ManBing>
    </div>
    <div class="pn-health-bottom">
        <ul class="pn-health-confirm-button clearfix">
            <!-- <li><a href="javascript:;" class="consult" @click="consult">咨询</a></li> -->
            <li><a href="javascript:;" class="white-orange i-cancel" @click="cancel()">部分为是</a></li>
            <li><a href="javascript:;" class="orange-white i-okey" @click="okey()">以上全否</a></li>
        </ul>
    </div>
    <div class="dailog-cancel" v-show="cancel_showflag">
            <div class="inner">
                <h3>您的健康告知不符合要求，无法投保</h3>
                <div class="inner-2" @click="download()">
                  <img src="../assets/images/downloadtip.png">
                  <p>下载平安健康APP<br/><span>查看更多保障</span></p>
                </div>
                <div class="bottom-btn">
                    <a href="javascript:void(0);" class="desc-ok" @click="cancel_showflag=false ">关闭</a>
                    <a href="javascript:void(0);" class="desc-ok" @click="download()">前往下载</a>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
// @ is an alias to /src
// 根api地址，通过环境变量的配置获取
const API_PATH = process.env.VUE_APP_API_URL;
// 业务api地址
const API_SERVICE = `${API_PATH}/mapi/serviceOnLine.json`;
const API_PLACE_ORDER = `${API_PATH}/mapi/insurance/insuranceBase/baseAPI/placeOrder.json`;
const API_GET_WECHAT_PAY_INFO = `${API_PATH}/mapi/insurance/insuranceRenew/baseAPI/getSignAndPayInfoWX.json`;

import ManBing from '@/views/health-notice-comp/health_notice_manbing';
import base from '../mixins/base';
export default {
  name: 'HealthNotice',
  mixins: [base],
  data() {
    return {
      name: '健康告知',
      cancel_showflag:false,
      insId: '',
      pageId: '',
      planId: '',
    }
  },
  components:{
    ManBing
  },
  computed: {
    
  },
  methods: {
    goBack() {
      if (this.$store.state.preRoute) {
        this.$router.go(-1);
      } else {
        window.history.go(-1);
      } 
    },
    //咨询
    consult() {
      let self = this;
      let url = 'https://eim.pingan.com.cn/appim/talk?weAppNo=PAJKX_DHHS_09&businessType=PAJKX&encryptStr=clientImNo=|customerNo=|customerName=|nickName=&extraInfo={%22enterIdentify%22:%22APPH5%22,%22label%22:[%22H5%22,%22APPH5%22,%22any%22]}'
      // let params = {"userId":infos.ab, "accessToken":infos.sb, "insId":insuranceId, "pageCode":'JKGZ'};
      // axios.post(API_SERVICE, {}).then((response) => {
      //     if (response.code === 1) {
      //       self.returnMas=response.data;
      //       let channelPageActivityInfo=response.data.channelPageActivityInfo;
      //       for(let i=0;i<channelPageActivityInfo.length;i++){
      //           let cur = channelPageActivityInfo[i];
      //           if(cur.operationType==2){
      //             self.banner1 = cur
      //           }else if(cur.operationType==3){
      //             self.banner2 = cur
      //           }
      //       }
      //     } else {
      //       this.showToast(response.msg)
      //     }
      // }).catch((error) => {
      //   this.showToast(error)
      // })
      //window.location.href=url;
      // let url = e.target.getAttribute('data-url');
      //let title = e.target.text || '';
      self.$router.push({
        name: 'ThirdPage',
        query: {
          url: url,
          consult:'true'
        }
      })
    },
    //部分为是
    cancel() {
      let self = this;
      self.cancel_showflag = true;
    },
    // 以上全否
    async okey() {
      let params = JSON.parse(this.$cookie.get('placeOrderParams')) || {};
      if (Object.keys(params).length === 0) {
        this.showToast('您还没有填写投保信息哦');
        return;
      }
      let payChannel = params.payChannel;
      let autoRenewal = params.autoRenewal;
      this.setUserInfoCookie(params.userId, params.accessToken);
      console.log(payChannel)
      this.showLoading();
      // 生成订单
      const response = await axios.post(API_PLACE_ORDER, params);
      this.hideLoading();
      if (response.code === 1) {
        let data = response.data;
        if (payChannel === 0 && autoRenewal == 1) { // 微信支付
          this.getWechatPayData(data.orderNo, data.price, params.userId, params.accessToken);
        } else { // 收银台支付
          let payUrl = data.payUrl;
          window.location.href = payUrl;
        }
      } else {
        this.showToast(response.msg);
      }
    },
    setUserInfoCookie(userId, accessToken) {
      this.$cookie.delete('p-userId');
      this.$cookie.delete('p-accessToken');
      this.$cookie.delete('p-insId');
      this.$cookie.delete('p-pageId');
      this.$cookie.set('p-userId', userId, {expires: '1h'});
      this.$cookie.set('p-accessToken', accessToken, {expires: '1h'});
      this.$cookie.set('p-insId', this.insId, {expires: '1h'});
      this.$cookie.set('p-pageId', this.pageId, {expires: '1h'});
    },
    // 微信签约支付
    getWechatPayData(orderNo, price, userId, accessToken) {
      let isWechatBrowser = this.$store.state.isWeChat;
      if (isWechatBrowser) {
        this.jsApiWechatPay(orderNo, price);
      } else {
        this.h5WechatPay(orderNo, price, userId, accessToken);
      }
    },
    // H5支付，非微信内浏览器
    async h5WechatPay(orderNo, price, userId, accessToken) {
      let params = {
        userId: userId,
        accessToken: accessToken,
        orderNo: orderNo,
        totalMoney: price * 1000000 / 10000,
        tradeType: 2,
        prepaySceneCode: '1',
      };
      this.showLoading();
      // 请求微信签约接口
      const response = await axios.post(API_GET_WECHAT_PAY_INFO, params);
      this.hideLoading();
      if (response.code === 1) {
        let data = response.data;
        let mwebUrl = data.mwebUrl;
        this.$cookie.delete('p-totalMoney');
        this.$cookie.set('p-totalMoney', price * 1000000 / 10000, {expires: '1h'});
        let redirect_url = window.location.origin + '/promotion/order-finish?orderNo=' + orderNo + '&us=' + userId + '&ac=' + encodeURIComponent(accessToken) + '&tmy=' + (price * 1000000 / 10000) + '&ins=' + this.insId + '&pid=' + this.pageId + '&srt=h5wechatpay&mwebUrl=' + mwebUrl;
        let url = mwebUrl + '&redirect_url=' + encodeURIComponent(redirect_url);
        window.location.replace(url);
      } else {
        this.showToast(response.msg);
      }
    },
    // 公众号支付，微信内部
    async jsApiWechatPay(orderNo, price) {
      let params = {
        userId: this.$cookie.get('p-userId'),
        accessToken: this.$cookie.get('p-accessToken'),
        orderNo: orderNo,
        totalMoney: price * 1000000 / 10000,
        tradeType: 4,
        prepaySceneCode: '1',
        openId: this.$cookie.get('p-openId'),
        url: window.location.href
      };
      this.showLoading();
      // 请求签约接口
      const response = await axios.post(API_GET_WECHAT_PAY_INFO, params);
      this.hideLoading();
      if (response.code === 1) {
        let data = response.data;
        if (typeof WeixinJSBridge == "undefined"){
          if( document.addEventListener ){
            document.addEventListener('WeixinJSBridgeReady', self.onBridgeReady(orderNo, data), false);
          } else if (document.attachEvent){
            document.attachEvent('WeixinJSBridgeReady',  self.onBridgeReady(orderNo, data)); 
            document.attachEvent('onWeixinJSBridgeReady',  self.onBridgeReady(orderNo, data));
          }
        }else{
          this.onBridgeReady(orderNo, data);
        }
      } else {
        this.showToast(response.msg);
      }   
    },
    // 调起微信内公众号支付
    onBridgeReady(orderNo, data) {
      let self = this;
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest', {
           "appId": data.appId,
           "timeStamp": data.timeStamp,
           "nonceStr": data.nonceStr,
           "package": data.packageValue,     
           "signType": data.signType,
           "paySign": data.paySign
        },
        function(res){
          if(res.err_msg == "get_brand_wcpay_request:ok" ){
            self.$router.replace({
              path: '/order-finish',
              query: {
                orderNo: orderNo
              },
            });
            //window.location.href = window.location.origin + '/promotion/order-finish?orderNo='+orderNo;
          } else {
            //self.showToast('未查询到支付信息，请稍后重试');
          } 
        }
      );
    },
    download(){
      var pa_from =  this.$store.state.re_from || 'bd_h5'
      // window.location.href="https://m.health.pingan.com/app/download/download.html"
      if(IsWeixin){
        location.href="http://a.app.qq.com/o/simple.jsp?pkgname=com.pa.health";
      }else{
        if(IsIOS){
        location.href="https://itunes.apple.com/us/app/ping-jian-kang-yi-dong-kou/id1159233677?ls=1&mt=8";
        }else{
        location.href="https://m.health.pingan.com/app/download/download.html?pa_from="+pa_from;
        }
      }
    }
  },
   mounted() {
    let self = this;
    let origin = window.location.origin;
    let shareConfig = {
      //分享标题
      title:"i康保·百万医疗（慢病版）",
      //分享图片地址
      imgUrl:origin+'/share/statics/images/product/101.png',
      //分享链接地址
      linkUrl:this.$cookie.get('p-share-link'),
      //分享描述文案
      description:"最高报销400万各类医疗费 指定慢病既往症也能保 保费最高优惠30%"
    }
    PinganHealth.wxShare(shareConfig);
  },
  created() {
    var self=this;
    let query = this.$route.query;
    this.insId = query.insId;
    this.planId = query.planId;
    this.pageId = query.pageId;
  }
}
</script>

<style scoped lang="stylus">
  .header
    width: 100%
    height: 1rem
    line-height: 1rem
    background-color: #fff
    color: #333
    text-align: center
    font-size: .34rem
    position: absolute
    top: 0
    left: 0
    display: flex
    z-index: 99
    border-bottom: 1px solid #f5f5f5
    .back-btn
      position: absolute
      top: .3rem
      left: .3rem
      width: .38rem
      height: .38rem
      img
        display: block
        width: 100%
        height: 100%  
    .title
      width: 100%
      text-align: center
  .content-wrapper
    padding-top: 1rem
  .pn-health-bottom
      background: #fff
      height: 67px
      position: fixed
      left: 0
      bottom: 0
      width: 100%
      line-height: 52px
      border-top: 1px solid #E8E8E8
      ul
        margin: 10px 15px
        li
          float: left
          width: 50%
          a
            color: #333
            display: block
            height: 40px
            line-height: 38px
            text-align: center
            border-radius: 5px
            margin: 0 .2rem;
        /*li:nth-child(1)
            width: 15%
        li:nth-child(2)
            width: 40%
            margin-left: 2%
        li:nth-child(3)
            width: 40%
            margin-left: 3%*/
      .consult
        height: 34px
        line-height: 34px
        margin-top: 3px
        font-size:10px
        &:before 
          display: block
          content: ""
          margin: 0 auto -7px
          width: 20px
          height: 20px
          background: url(https://m.health.pingan.com/share/images/consult_pic.png) no-repeat
          background-size: 100%
      .pn-health-confirm-button 
        &:after
          content: ''
          display: block
          overflow: hidden
          visibility: hidden
          clear: both
        .i-okey 
          background-image: linear-gradient(270deg,#fe9219,#f04d16)
          border: none
          height: 40px
          line-height: 40px
          border-radius: 22px
          font-size: 15px
          color: #fff
          background: #f60
        .i-cancel
          border: 1px solid #FD8537
          color: #f60
          background: #fff
          border-radius: 22px
          font-size: 15px
  .dailog-cancel
      position: fixed
      top: 0
      left: 0
      width: 100%
      height: 100%
      background: rgba(0,0,0,.3)
      z-index: 100
      .inner
          position: absolute
          top: 50%
          left: 50%
          width: 315px
          border-radius: 5px
          -webkit-transform: translate(-50%,-50%)
          -moz-transform: translate(-50%,-50%)
          transform: translate(-50%,-50%)
          background: #fff
          padding: 21px 15px
          color: #666
          h3
              color: #333
              font-weight: 400
              font-size: 15px
              margin: 0 auto
              text-align: center
          .inner-2
              border-top: 1px solid #EEEEEE
              margin-top: 21px
              text-align: center
              margin-bottom: 24px
              img
                  width: 35px
                  margin: 20px 0 15px 0
              p
                  color: #333333
                  font-size: 15px
                  font-weight: 500
                  span
                      color: #333333
                      font-size: 14px
                      font-weight: 400
        .bottom-btn 
            a
              height: 35px
              width: 135px
              border-radius: 35px
              border: 1px solid #333
              display: inline-block
              font-size: 14px
              text-align: center
              line-height: 35px
              color: #333
            a+a
              margin-left: 15px
              background: #FF6600
              color: #fff
              border: none
</style>
